import VBottomNavigation from './VBottomNavigation';
export { VBottomNavigation };
export default VBottomNavigation;
//# sourceMappingURL=index.js.map